import { render, staticRenderFns } from "./c_checked_tab.vue?vue&type=template&id=90a51e80&scoped=true"
import script from "./c_checked_tab.vue?vue&type=script&lang=js"
export * from "./c_checked_tab.vue?vue&type=script&lang=js"
import style0 from "./c_checked_tab.vue?vue&type=style&index=0&id=90a51e80&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a51e80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90a51e80')) {
      api.createRecord('90a51e80', component.options)
    } else {
      api.reload('90a51e80', component.options)
    }
    module.hot.accept("./c_checked_tab.vue?vue&type=template&id=90a51e80&scoped=true", function () {
      api.rerender('90a51e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_checked_tab.vue"
export default component.exports